import Vue from 'vue';
import Vuex from '@/store';
import VueRouter from 'vue-router';
import Layout from '@/layout';
import Home from '@/views/home';
import * as FN from '@/public';

Vue.use(VueRouter);

// 静态路由
const routes = [
  {
    path: '',
    routeName: '布局',
    component: Layout,
    meta: { rank: 1 },
    children: [
      {
        path: '/home',
        routeName: "首页",
        component: Home
      },
      {
        path: "/comprehensiveSearch",
        routeName: '综合检索',
        component: () => import('@/views/comprehensiveSearch')
      },
      {
        path: "/standard",
        routeName: '标准检索',
        component: () => import('@/views/standard')
      },
      {
        path: "/digitization",
        routeName: '数字化标准比对',
        component: () => import('@/views/digitization')
      },
      {
        path: "/smartQA",
        routeName: '标准智能问答',
        component: () => import('@/views/smartQA')
      },
      {
        path: "/benchmarking",
        routeName: '勘察设计对标 0 / 安装施工对标 1',
        component: () => import('@/views/benchmarking')
      },
      {
        path: "/standardTranslation",
        routeName: '中国标准英文出版物',
        component: () => import('@/views/standardTranslation')
      },
      {
        path: "/technicalRegulations",
        routeName: '国别技术法规',
        component: () => import('@/views/technicalRegulations')
      },
      {
        path: "/languageService",
        routeName: '标准化语言服务',
        component: () => import('@/views/languageService')
      },
      {
        path: "/call",
        routeName: '国际招标信息',
        component: () => import('@/views/call')
      },
      {
        path: "/informationNavigation",
        routeName: '国际信息导航',
        component: () => import('@/views/informationNavigation')
      },
      {
        path: "/standardList",
        routeName: '国际电力工程清单',
        component: () => import('@/views/standardList'),
        children: [
          {
            path: "/standardList/item",
            routeName: '项目页面',
            component: () => import('@/views/standardList/item'),
          },
          {
            path: "/standardList/standard",
            routeName: '标准页面',
            component: () => import('@/views/standardList/standard'),
          }
        ]
      },
      {
        path: "/platformAssistant",
        routeName: '平台助手',
        component: () => import('@/views/platformAssistant')
      },
      {
        path: "/ceppeaStandard",
        routeName: 'CEPPEA标准',
        component: () => import('@/views/ceppeaStandard')
      },
      {
        path: "/feedback",
        routeName: '需求反馈',
        component: () => import('@/views/feedback')
      },
      {
        path: "/message",
        routeName: '消息',
        component: () => import('@/views/message')
      },
      {
        path: "/individualCenter",
        routeName: '个人中心',
        component: () => import('@/views/individualCenter'),
        children: [
          {
            path: "settings",
            routeName: "资料设置",
            component: () => import('@/views/individualCenter/settings'),
          },
          {
            path: "collect",
            routeName: "用户收藏",
            component: () => import('@/views/individualCenter/collect'),
          },
          {
            path: "myOrder",
            routeName: "我的订单",
            component: () => import('@/views/individualCenter/myOrder'),
          },
          {
            path: "orderManage",
            routeName: "订单管理",
            component: () => import('@/views/individualCenter/orderManage'),
          }
        ]
      },
      {
        path: "/ceppeaPublish",
        routeName: '已发布CEPPEA标准',
        component: () => import('@/views/ceppeaPublish')
      },
      {
        path: "/newStandardList",
        routeName: '最近更新标准',
        component: () => import('@/views/newStandardList')
      },
      {
        path: "/ceppeaSolicit",
        routeName: '中国电力规划设计协会征求意见',
        component: () => import('@/views/ceppeaSolicit')
      },
      {
        path: "/container",
        routeName: 'iframe容器组件',
        component: () => import('@/views/container')
      },
      {
        path: "/forget",
        routeName: '忘记密码',
        component: () => import('@/views/forget')
      },
      // {
      //   path: '/onlineEditing',
      //   routeName: "在线编辑excel",
      //   component: () => import('@/views/onlineEditing')
      // },
      // {
      //   path: '/wordEditing',
      //   routeName: "在线编辑word",
      //   component: () => import('@/views/wordEditing')
      // },
      {
        path: '/test',
        routeName: "测试",
        component: () => import('@/views/test')
      }
    ]
  },
  {
    path: '',
    routeName: '布局',
    component: Layout,
    meta: { rank: 1 },
    children: [
      {
        path: '/detailsPage/internationalBidding',
        routeName: '国际招标详情',
        component: () => import('@/views/detailsPage/internationalBidding')
      },
      {
        path: '/detailsPage/ceppea',
        routeName: 'ceppea详情',
        component: () => import('@/views/detailsPage/ceppea')
      },
      {
        path: '/detailsPage/industryInformationBase',
        routeName: '双语阅读详情',
        component: () => import('@/views/detailsPage/industryInformationBase')
      },
      {
        path: '/detailsPage/order',
        routeName: '我的订单详情',
        component: () => import('@/views/detailsPage/order')
      },
      {
        path: '/detailsPage/standardComparison',
        routeName: '数字化标准数据比对-比对列表及结果',
        component: () => import('@/views/detailsPage/standardComparison')
      },
      {
        path: '/detailsPage/standardDetail',
        routeName: '标准详情',
        component: () => import('@/views/detailsPage/standardDetail')
      },
      {
        path: '/detailsPage/standardDetail/derive',
        routeName: '导出标准详情',
        component: () => import('@/views/detailsPage/standardDetail/derive')
      },
      {
        path: '/detailsPage/standardDetail/view',
        routeName: '标准文本在线查看',
        component: () => import('@/views/detailsPage/standardDetail/view')
      },
      {
        path: '/detailsPage/benchmarking',
        routeName: '勘察设计对标详情',
        component: () => import('@/views/detailsPage/benchmarking')
      },
      // {
      //   path: '/detailsPage/underConstruction',
      //   routeName: '中国电力施工部分标准与国际标准和国外标准比较研究',
      //   component: () => import('@/views/detailsPage/underConstruction')
      // },
    ]
  },
  {
    path: '*',
    routeName: '404',
    component: () => import('@/views/page404')
  }
];

// 动态路由
const dynamicRouting = [
  {
    path: '',
    routeName: '布局',
    component: Layout,
    meta: { rank: 1 },
    children: []
  }
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  // scrollBehavior: () => ({ y: 0 }), //切换路由滚动的位置
  routes
});

// 路由加载进度
let routerTime = null;

let clearTime = () => {
  clearInterval(routerTime);
  routerTime = null;
};

router.beforeEach((to, form, next) => {
  clearTime();
  Vuex.commit('setProgress', ++Vuex.state.progress);
  routerTime = setInterval(() => {
    // 模拟一个进度
    let newNum = Vuex.state.progress + (Math.random() * 2);
    let value = newNum > 98 ? 99 : newNum;
    Vuex.commit('setProgress', value);
  }, 300);
  next();
});

router.afterEach((to, from) => {
  Vue.nextTick(() => {
    // 路由加载完成的逻辑
    Vuex.commit('setProgress', 100);
    clearTime();
    routerTime = setTimeout(() => {
      Vuex.commit('setProgress', 0);
      clearTime();
    }, 300);
  });
});

//清空路由的方法
export function resetRouter() {
  let length = window.history.length - 1;
  if (length > 1) router.go(-length);
};

// 计算路由
export function dynamic() {
  if (FN.getUser()) {
    // 登录了就将动态路由加入进去
    dynamicRouting.forEach(item => router.addRoute(item))
  } else {
    // 未登录初始化路由
    const createRouter = new VueRouter({
      mode: 'history',
      base: process.env.BASE_URL,
      routes
    });
    router.matcher = createRouter.matcher;
  };
};

dynamic();

router['__proto__'].clearRouter = resetRouter;

export default router